import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [
  {
    exact: true,
    path: '/home/polymerize/theme',
    owner: '/home',
    authority: 'themeList',
    component: Loadable({
      loader: () => import('./index'),
      loading: () => <RouteLoading />
    })
  },
  {
    exact: true,
    path: '/home/polymerize/theme/new',
    owner: '/home',
    authority: 'themeAdd',
    component: Loadable({
      loader: () => import('../edit/new'),
      loading: () => <RouteLoading />
    })
  },
  {
    exact: true,
    path: '/home/polymerize/theme/:id/edit',
    owner: '/home',
    authority: 'themeMod',
    component: Loadable({
      loader: () => import('../edit/mod'),
      loading: () => <RouteLoading />
    })
  }

];